import Glide from '@glidejs/glide';

class timelineHelper {

    constructor() {
    }


    initSlider(el) {
        let glide = new Glide(el, {
            'type': 'carousel',
            'autoplay': '10000',
            'hoverpause': 'true',
            'animationDuration': 0
        }).mount();

        glide.on(['run.before'], function () {

            let target = document.getElementById("topOfTimeline")
            target.scrollIntoView();
        });
    }
}

window.app.add('timeline', new timelineHelper());